// Potwierdzenie akcji rozwijane w miejscu (bez popupu): pasek z pytaniem i dwoma przyciskami
// dopinany na koniec wskazanego kontenera (wiersz produktu, pasek opcji koszyka).
// Naraz otwarte jest tylko jedno; zamyka je Anuluj, Esc, kliknięcie poza paskiem
// albo ponowne kliknięcie przycisku, który je otworzył.

let current = null;

export function closeInlineConfirm() {
    if (!current) return;

    const { element, trigger, onKeydown, onPointerdown } = current;
    current = null;

    document.removeEventListener('keydown', onKeydown);
    document.removeEventListener('pointerdown', onPointerdown);
    element.remove();
    trigger?.removeAttribute('aria-expanded');
}

export default function inlineConfirm({ host, trigger, title, text = '', confirmLabel, cancelLabel = 'Anuluj', onConfirm }) {
    if (current?.trigger === trigger) {
        closeInlineConfirm();
        return;
    }

    closeInlineConfirm();

    const element = document.createElement('div');
    element.className = 'cart-confirm';
    element.setAttribute('role', 'group');
    element.setAttribute('aria-label', title);
    element.innerHTML = `
        <div>
            <div class="cart-confirm-panel">
                <p>
                    <strong>${title}</strong>
                    ${text ? `<span>${text}</span>` : ''}
                </p>
                <div class="cart-confirm-actions">
                    <button type="button" class="small-button" data-cancel>${cancelLabel}</button>
                    <button type="button" class="small-button delete" data-confirm>${confirmLabel}</button>
                </div>
            </div>
        </div>`;

    const cancel = () => {
        closeInlineConfirm();
        if (trigger?.isConnected) trigger.focus();
    };

    const onKeydown = (e) => {
        if (e.key === 'Escape') cancel();
    };

    const onPointerdown = (e) => {
        if (!element.isConnected) {
            closeInlineConfirm();
            return;
        }

        if (element.contains(e.target) || trigger?.contains(e.target)) return;

        closeInlineConfirm();
    };

    element.querySelector('[data-cancel]').addEventListener('click', cancel);
    element.querySelector('[data-confirm]').addEventListener('click', () => {
        closeInlineConfirm();
        onConfirm();
    });

    document.addEventListener('keydown', onKeydown);
    document.addEventListener('pointerdown', onPointerdown);

    host.appendChild(element);
    trigger?.setAttribute('aria-expanded', 'true');
    current = { element, trigger, onKeydown, onPointerdown };

    element.querySelector('[data-cancel]').focus({ preventScroll: true });

    // Pasek rozwija się animacją (0.25 s), więc do widoku przewijamy go dopiero po niej.
    setTimeout(() => element.scrollIntoView({ block: 'nearest' }), 300);
}
